'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contextualNodeAttributes"];
import tinymce from 'tinymce';
import LineHeightMenu from 'rich-text-lib/components/formatting/LineHeightMenu';
import { hsformattingConfig } from 'tinymce-plugins/constants/hsformatting';
import { getHsformattingSettings } from '../utils';
import { CHANGE_LINE_HEIGHT } from '../constants/usageTracking';
import { trackInteraction } from '../utils/usageTracking';
import { applyLineHeight } from './utils';
import { LINE_HEIGHT_FORMAT, i18nNameSpace } from '../constants/hsformatting';
import { CANVAS_LINEHEIGHT } from '../constants/toolbar';
import { i18nWithNameSpace } from '../utils/i18n';
import { getMatchingValueHandler } from '../utils/formatting';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = i18nWithNameSpace(i18nNameSpace);
function registerLineHeightFormat({
  target: editor
}) {
  editor.formatter.register(LINE_HEIGHT_FORMAT, {
    selector: 'p,h1,h2,h3,h4,h5,h6,ul,ol,li,div',
    styles: {
      lineHeight: '%value'
    }
  });
}
export function addLineheightSelects(editor) {
  editor.on('PreInit', registerLineHeightFormat);
  const lineheights = getHsformattingSettings(editor.settings, hsformattingConfig.LINE_HEIGHTS, []);
  const items = lineheights.map(value => {
    return {
      text: {
        raw: value.toString()
      },
      value
    };
  });
  const handleChange = value => {
    const lineHeightApplied = applyLineHeight(editor, value);
    trackInteraction(editor, 'tinymceFormatting', CHANGE_LINE_HEIGHT, {
      value: lineHeightApplied.toString(),
      method: 'toolbar',
      version: 'v2'
    });
  };
  const valueMatcher = getMatchingValueHandler(editor, LINE_HEIGHT_FORMAT, items);
  const getFormattingAttributes = evt => {
    const value = valueMatcher(evt);
    return {
      [CANVAS_LINEHEIGHT]: value
    };
  };
  tinymce.canvas.addNodeChangeHandler(editor, {
    getFormattingAttributes
  });
  tinymce.canvas.addButton(editor, CANVAS_LINEHEIGHT, () => ({
    renderControl: props => {
      const {
          contextualNodeAttributes
        } = props,
        rest = _objectWithoutPropertiesLoose(props, _excluded);
      const {
        [CANVAS_LINEHEIGHT]: lineHeight
      } = contextualNodeAttributes;
      return /*#__PURE__*/_jsx(LineHeightMenu, Object.assign({
        "data-test-id": CANVAS_LINEHEIGHT,
        tooltip: i18nKey('lineHeightToolbarButton'),
        onChange: handleChange,
        dropdownClassName: "mce-hubspot-menu",
        options: items,
        lineHeight: lineHeight
      }, rest));
    }
  }));
}